import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "divider"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "flex-fill" }
const _hoisted_4 = { key: 1 }

import {ContextMenuExposeInterface, ContextMenuItemInterface} from "~/core-ui/vue/ui/context-menu/ContextMenuInterface";
import {computed, getCurrentInstance, onUpdated, ref} from "vue";
import Events from "~/ts/library/Events";
import Dictionary from "~/ts/library/Dictionary";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import WindowHelper from "~/ts/library/WindowHelper";
import Random from "~/ts/library/Random";


const __default__ = {
    name: "ContextMenu"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {

let emits = __emit;

let visible = ref(false);
let lastEvent = ref<MouseEvent>();
let menuItems = ref<ContextMenuItemInterface[]>([]);
let instance = getCurrentInstance().proxy;
let scrollbar = ref(false);
let elementHeight = ref(0);

const margin = 15;


addDisposableEvent(Events.addEventListener("click", document, function () {
    close();
}));
addDisposableEvent(Events.addEventListener("contextmenu", document, function (event) {
    if (lastEvent.value != event) {
        close();
    }
}));

function close() {
    elementHeight.value = null;
    lastEvent.value = null;
    visible.value = false;
    emits("close");
}

function onItemClick(item: ContextMenuItemInterface) {
    if (!item.disabled) {
        if (item.onClick) {
            item.onClick();
            close();
        }
    }
}

let positionCss = computed<Dictionary<string>>(() => {
    let newPositionCss: Dictionary<string> = {};
    let event = lastEvent.value;
    if (event) {
        let windowHeight = WindowHelper.getSize().height;

        if (window.innerWidth / 2 < event.clientX) {
            newPositionCss.right = `${window.innerWidth - event.clientX}px`;
        } else {
            newPositionCss.left = `${event.clientX}px`;
        }
        let maxHeight: number;
        if (window.innerHeight / 2 < event.clientY) {
            let bottom = getOptimalPosition(windowHeight - event.clientY, windowHeight);
            maxHeight = windowHeight - bottom;
            newPositionCss.bottom = `${bottom}px`;
        } else {
            let top = getOptimalPosition(event.clientY, windowHeight);
            newPositionCss.top = `${top}px`;
            maxHeight = windowHeight - top;
        }
        maxHeight -= margin;
        scrollbar.value = elementHeight.value && elementHeight.value > maxHeight;
        if (scrollbar.value) {
            newPositionCss.maxHeight = `${maxHeight}px`;
        }
    }
    return newPositionCss;
});

function getOptimalPosition(value: number, windowHeight: number) {
    value = Math.max(value, margin);
    let maxHeight = windowHeight - value - margin;
    if (elementHeight.value && elementHeight.value > maxHeight) {
        let delta = elementHeight.value - maxHeight;
        return Math.max(value - Math.min(value, delta), margin);
    }

    return value;

}


__expose<ContextMenuExposeInterface>({
    openMenu: (event, items) => {
        elementHeight.value = null;
        menuItems.value = items;

        lastEvent.value = event;

        visible.value = true;
    }
});


onUpdated(() => {
    if (!elementHeight.value) {
        let el = instance.$el as HTMLElement;
        elementHeight.value = el && el.nodeType == 1 ? el.getBoundingClientRect().height : null;
    }
});

let popperOptionsDictionary = ref<Dictionary<string>>({});

function getPopperOptions(key: any) {
    let value = popperOptionsDictionary.value[key];
    return {
        foo: value
    }
}

function repositionPopper(key: any) {
    popperOptionsDictionary.value[key] = Random.uid();
}

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_unref(visible))
    ? (_openBlock(), _createBlock(_component_el_card, {
        key: 0,
        style: _normalizeStyle({
            ..._unref(positionCss)
        }),
        class: _normalizeClass({'p-0 context-menu el-dropdown__popper': true, scrollbar: _unref(scrollbar)})
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "wrapper",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuItems), (item, key) => {
              return (_openBlock(), _createBlock(_component_el_popover, {
                "popper-class": `context-menu-popper `+ item.popover?.popperClass,
                placement: "right-end",
                "popper-options": getPopperOptions(key),
                persistent: false
              }, {
                reference: _withCtx(() => [
                  (item.isDividerLine)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass({
                                'menu-item el-dropdown-menu__item': true,
                                divider: item.isDivider,
                                'is-disabled': item.isDivider || item.disabled
                            }),
                        onClick: ($event: any) => (onItemClick(item))
                      }, [
                        (item.icon)
                          ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                              key: 0,
                              icon: item.icon,
                              class: _normalizeClass(['mr-3', item.iconClass ?? ''])
                            }, null, 8, ["icon", "class"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_3, _toDisplayString(item.text), 1),
                        (item.popover)
                          ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                              key: 1,
                              icon: "chevron-right",
                              class: "ml-3 mr-0"
                            }))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_2))
                ]),
                default: _withCtx(() => [
                  (item.popover)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.popover.component), _mergeProps({
                        key: 0,
                        ref_for: true
                      }, item.popover.props, {
                        onReposition: ($event: any) => (repositionPopper(key)),
                        onClose: close
                      }), null, 16, ["onReposition"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4))
                ]),
                _: 2
              }, 1032, ["popper-class", "popper-options"]))
            }), 256)),
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      }, 8, ["style", "class"]))
    : _createCommentVNode("", true)
}
}

})